import * as React from "react";
import { useEffect } from "react";
import memoize from "lodash/memoize";
import useFieldTypes from "views/logic/fieldtypes/useFieldTypes";
import { Col, ControlLabel, FormGroup, HelpBlock, Row } from "components/bootstrap";
import { Select, Spinner } from "components/common";
import { naturalSortIgnoreCase } from "util/SortUtils";
import { useStore } from "stores/connect";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import { ALL_MESSAGES_TIMERANGE } from "views/Constants";
import { LookupTablesActions, LookupTablesStore } from "stores/lookup-tables/LookupTablesStore";
const LOOKUP_PERMISSIONS = ["lookuptables:read"];
const LookupTableFields = ({
  onTableNameChange,
  onKeyChange,
  selectedTableName,
  selectedKeyName,
  nameValidation,
  keyValidation,
  lookupTableNameLabel = "",
  lookupTableKeyLabel = "",
  customKeyField = null
}) => {
  const { data: allFieldTypes } = useFieldTypes([], ALL_MESSAGES_TIMERANGE);
  const lookupTables = useStore(LookupTablesStore);
  const currentUser = useCurrentUser();
  useEffect(() => {
    if (!isPermitted(currentUser.permissions, LOOKUP_PERMISSIONS)) {
      return;
    }
    LookupTablesActions.searchPaginated(1, 0, void 0, false);
  }, [currentUser.permissions]);
  if (!isPermitted(currentUser.permissions, LOOKUP_PERMISSIONS)) {
    return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6, lg: 5 }, /* @__PURE__ */ React.createElement("p", null, "No Lookup Tables found.")));
  }
  const formatMessageFields = memoize(
    (fieldTypes) => fieldTypes.sort((ftA, ftB) => naturalSortIgnoreCase(ftA.name, ftB.name)).map((fieldType) => ({
      label: `${fieldType.name} \u2013 ${fieldType.value.type.type}`,
      value: fieldType.name
    })),
    (fieldTypes) => fieldTypes.map((ft) => ft.name).join("-")
  );
  const formatLookupTables = (tables) => tables.sort((lt1, lt2) => naturalSortIgnoreCase(lt1.title, lt2.title)).map((table) => ({ label: table.title, value: table.name }));
  const isLoading = !allFieldTypes || !lookupTables.tables;
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading Field Provider information..." });
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "lookup-provider-table", validationState: nameValidation ? "error" : null }, /* @__PURE__ */ React.createElement(ControlLabel, null, lookupTableNameLabel || "Select Lookup Table"), /* @__PURE__ */ React.createElement(
    Select,
    {
      name: "event-field-table-name",
      placeholder: "Select Lookup Table",
      onChange: onTableNameChange,
      options: formatLookupTables(lookupTables.tables),
      value: selectedTableName,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, nameValidation || "Select the Lookup Table which should be used to get the value."))), customKeyField ? /* @__PURE__ */ React.createElement(Col, { md: 6 }, customKeyField) : /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "lookup-provider-table", validationState: keyValidation ? "error" : null }, /* @__PURE__ */ React.createElement(ControlLabel, null, lookupTableKeyLabel || "Lookup Table Key Field"), /* @__PURE__ */ React.createElement(
    Select,
    {
      name: "lookup-provider-key",
      placeholder: "Select Field",
      onChange: onKeyChange,
      options: formatMessageFields(allFieldTypes),
      value: selectedKeyName,
      allowCreate: true,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, keyValidation || "Message Field name whose value will be used as Lookup Table Key."))));
};
export default LookupTableFields;
